import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import { StyledBoxVarientTwo } from "../../atoms/box/main";
import CardShimmer, { InferenceCardShimmer } from "../shimmer/card/main";
import ChartShimmer from "../shimmer/chart/main";
import MapShimmer from "../shimmer/Map/main";
import uniqid from "uniqid";
import { stateType } from "../../../store/store.type";

const AppLayoutSkeleton = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");
  const sidePanelOpen = useSelector(
    (sel: stateType) => sel.panelSlice.panelOpen,
  );
  const { userType } = useSelector(
    (sel: stateType) => sel.userProfileSlice.data,
  );
  const StyledBoxVarientTwoOverride = {
    "@media (max-width: 1520px)": {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            padding: sidePanelOpen
              ? "1.5rem 1.5rem 1.125rem 1.5rem"
              : "1.5rem 1.75rem 1.125rem 1.75rem",
            // marginTop: "4.062rem",
          }}
        >
          <Grid container alignItems={"center"} rowSpacing={{ xs: 1, sm: 1.5 }}>
            <Grid item xs={12}>
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{ borderRadius: "1rem", width: "30%" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                sx={{ borderRadius: "1rem" }}
              ></Skeleton>
            </Grid>
            <Grid item xs={10.2} md={11} lg={11}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                sx={{ borderRadius: "1rem", width: "100px" }}
              ></Skeleton>
            </Grid>
            <Grid item xs={1.8} sm={1.2} md={1} lg={1}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                sx={{ width: "70px", height: "20px", borderRadius: "1rem" }}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid
        container
        rowSpacing={{ xs: 2, sm: 4 }}
        columnSpacing={{ xs: 2, sm: 4 }}
      >
        <Grid item xs={12}>
          <StyledBoxVarientTwo
            sx={sidePanelOpen === false ? {} : StyledBoxVarientTwoOverride}
          >
            <Grid container>
              {
                <Grid
                  data-tut="summary-title-card"
                  container
                  rowSpacing={{ xs: 2, md: 1, lg: sidePanelOpen ? 3.5 : 4.5 }}
                  columnSpacing={{
                    xs: 2,
                    md: 1,
                    lg: sidePanelOpen ? 3.5 : 4.5,
                  }}
                >
                  {new Array(4).fill(0).map(() => (
                    <CardShimmer
                      borderRadius={"1rem"}
                      color={"#F7F9FB"}
                      width={"100%"}
                      height={"9.2rem"}
                      key={uniqid()}
                    />
                  ))}
                </Grid>
              }
            </Grid>
          </StyledBoxVarientTwo>
        </Grid>
        <Grid item xs={12}>
          <StyledBoxVarientTwo
            sx={sidePanelOpen === false ? {} : StyledBoxVarientTwoOverride}
          >
            <Grid
              container
              rowSpacing={{ xs: 2, lg: sidePanelOpen ? 3.5 : 4.5, md: 1 }}
              columnSpacing={{ xs: 2, lg: sidePanelOpen ? 3.5 : 4.5, md: 1 }}
            >
              {!isSmallScreen && (
                <MapShimmer
                  height={"18.75rem"}
                  width={"100%"}
                  borderRadius={"1rem"}
                  userType={userType}
                />
              )}
              {userType === "RegenAg" && (
                <InferenceCardShimmer
                  width="100%"
                  height="18.61rem"
                  borderRadius="1rem"
                />
              )}
              {isMediumScreen && (
                <ChartShimmer
                  width="100%"
                  height={"18.56rem"}
                  color="#F7F9FB"
                  borderRadius="1rem"
                  fullRow={false}
                />
              )}
            </Grid>
          </StyledBoxVarientTwo>
        </Grid>
        <Grid item xs={12}>
          <StyledBoxVarientTwo
            sx={sidePanelOpen === false ? {} : StyledBoxVarientTwoOverride}
          >
            <Grid
              container
              rowSpacing={{
                xs: 1,
                md: 1,
                sm: 4,
                lg: sidePanelOpen ? 3.5 : 4.5,
              }}
              columnSpacing={{
                xs: 1,
                md: 1,
                sm: 4,
                lg: sidePanelOpen ? 3.5 : 4.5,
              }}
            >
              {
                <ChartShimmer
                  width="100%"
                  height="18.56rem"
                  color="#F7F9FB"
                  borderRadius="1rem"
                  fullRow={isMediumScreen}
                />
              }
              {!isMediumScreen && (
                <ChartShimmer
                  width="100%"
                  height={"18.56rem"}
                  color="#F7F9FB"
                  borderRadius="1rem"
                  fullRow={false}
                />
              )}
            </Grid>
          </StyledBoxVarientTwo>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default AppLayoutSkeleton;
